module.exports = __webpack_public_path__ + "img/LaravelBookReview.5bdf4f31.png";